<template>
  <div >
    <div v-if="tableLoader">
      <Loader />
    </div>
    <div class="card tw-mt-4" >
      <div class="tw-flex tw-w-full tw-justify-between tw-flex-wrap tw-items-center ">
        <div class="d-flex w-full flex-wrap tw-items-center" id="tableFilter">
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date Range"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              v-model="dateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1 ml-0"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Report Type"][selectedLanguage.key] }}
            </div>

            <multiselect
              @input="handleReportSelection"
              v-model="selectedReportType"
              class="text-capitalize"
              :options="reportTypeList"
              track-by="triger_id"
              label="trigger_name"
              :multiple="true"
              :searchable="false"
              placeholder="Select Report Type"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedReportType?.length == reportTypeList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedReportType"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.trigger_name }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>

          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Batch Time
            </div>
            <multiselect
              v-model="selectedBatch"
              class="text-capitalize"
              :options="batchList"
              track-by="batch"
              label="displayname"
              :multiple="true"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedBatch?.length === batchList?.length ? 1 : 100"
              @input="changeBatchTime"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedBatch"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 220px; max-width: 220px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              Username
            </div>
            <multiselect
              v-model="selectedUserName"
              class="text-capitalize"
              :options="userNameList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Username"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="selectedUserName?.length === userNameList?.length ? 1 : 100"
              @input="handleUsernameSelection"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedUserName"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
            Status
            </div>
            <multiselect
              v-model="selectedStatus"
              limit="1"
              :options="statusList"
              :multiple="true"
              :searchable="false"
              placeholder="Select Status"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              :limit="selectedStatus?.length === statusList?.length ? 1 : 100"

              @input="handleStatusSelection"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedStatus"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <button
            class="btn primarycolor py-2 tw-mt-4"
            @click="handleApplyFilters"
          >
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>
        <div @click="openModal" class="tw-cursor-pointer tw-mt-2 tw-p-2 tw-text-primary_brand">Create Report</div>
      </div>
      <!-- <div>Create report</div> -->
    </div>
    <div class="card">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="d-flex overflow-auto sovReviewedTab">
          <h3
            class="tw-text-lg tw-font-[500] tw-text-primary_brand tw-mr-2 tw-mb-3"
            style="cursor: pointer"
          >
            Reports
          </h3>
        </div>
        <!-- <button
          class="btn primarycolor py-2 tw-mb-2 tw-mx-2"
          @click="exportSentimentTable"
        >
          {{ translatedLang["Export"][selectedLanguage.key] }}
        </button> -->
      </div>
      <div class="borderBetweenTab"></div>
      <div >
        <div
          class="summaryContainer tw-mx-0"
          v-if="Object.keys(viewReportsTableData).length"
        >
          <table id="sentimentAnalysis" class="tw-w-full">
            <thead class="">
              <tr>
                <th  v-for="head of viewReportsTableData.headers" :key="head.key" >{{ head.label }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, idx) of viewReportsTableData.data"
                :key="data.id + '|' + idx"
                class="tw-border tw-border-[#d4d4d4]"
              >
               <td v-for="head of viewReportsTableData.headers" :key="head.key">
                <div v-if="head.key=='file_url'" class="tw-flex tw-justify-center">
                  <a v-if="data.file_url" :href="data.file_url">Download</a>
                </div>
                <div v-else> {{data[head.key] }} </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <noData :loaderVariable="tableLoader" />
        </div>
      </div>
    </div>

    <b-modal
      v-model="isCreatingReportModal"
      size="md"
      title="Create Report"
      @hidden="resetModal"
    >
      <div >
         <b-input-group class="input-group">
              <label  
                  class="tw-mb-2 text-[12px]  tw-text-[#505050]">Report
                  Name</label>
              <div class="">
                  <input type="text" v-model="reportName" class="tw-pl-[12px]" placeholder="Enter report name"
                      autocomplete="" @inpute="()=>(flagError=false, reportNameErrorMessage='')"
                      :class="{ danger: flagError, reportName: !flagError }" />
                      <label class="danger tw-text-[12px] " v-if="flagError" >{{reportNameErrorMessage}}</label>
              </div>
          </b-input-group>
          <div class="tw-grid tw-grid-cols-2 tw-gap-4 tw-mt-3 tw-mb-3">
            <div
              class="customMultiselectCommon mr-2"
              style="min-width: 200px; max-width: 100%"
            >
              <div
                class="mb-1 ml-0"
                style="font-size: 14px; font-weight: 500; color: #1e1e1e"
              >
                Report Type
              </div>
              <multiselect
                @input="handleCreateReporTypeSelection"
                v-model="selectedCreatedReportType"
                class="text-capitalize"
                :options="createReportTypeList"
                track-by="triger_id"
                label="trigger_name"
                :multiple="false"
                :searchable="false"
                placeholder="Select Report Type"
                :showLabels="false"
                :close-on-select="true"
                :allow-empty="true"
              >
              </multiselect>
            </div>
            <div
              class="customMultiselectCommon mr-2 "
              style="min-width: 200px; max-width: 100%"
            >
            <div
                class="mb-1 ml-0"
                style="font-size: 14px; font-weight: 500; color: #1e1e1e"
              >
                Batch Type
              </div>
              <multiselect
                v-model="selectedCreatedBatch"
                class="text-capitalize"
                :options="createBatchList"
                track-by="batch"
                label="displayname"
                :multiple="false"
                :searchable="false"
                placeholder="Select Report Type"
                :showLabels="false"
                :close-on-select="false"
                :allow-empty="true"
              >
              </multiselect>
            </div>
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-gap-3 tw-mb-3">
            <div
              class="customMultiselectCommon mr-2"
              style="min-width: 200px; max-width: 100%"
            >
              <div
                class="mb-1 ml-0"
                style="font-size: 14px; font-weight: 500; color: #1e1e1e"
              >
                Select Channel
              </div>
              <multiselect
                @input="handleCreateReportChannelSelection"
                v-model="selectedCreatedChannel"
                class="text-capitalize"
                :options="createChannelList"
                track-by="key"
                label="value"
                :multiple="true"
                :searchable="false"
                placeholder="Select Report Type"
                :showLabels="false"
                :close-on-select="false"
                :allow-empty="true"
                :limit="
                  selectedCreatedChannel?.length == createChannelList?.length ? 1 : 100
                "
              >
                <template #option="{ option }">
                  <div class="tw-flex tw-gap-2">
                    <input
                      type="checkbox"
                      :value="option"
                      v-model="selectedCreatedChannel"
                    />
                    <div class="custom-option text-capitalize">
                      {{ option.value }}
                    </div>
                  </div>
                </template>
              </multiselect>
            </div>
           <div class="mr-2">
            <div
              class="mb-1 "
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
             Select Interval
            </div>
            <date-range-picker
              v-model="dateRangeCreatedReport"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          </div>
          <div class="tw-flex tw-justify-end  tw-items-center tw-border-t-[1px] tw-border-[#D5D5D5] ">
                <button class=" tw-mt-[22px] tw-text-[#8C0000] tw-px-4 tw-mr-4 tw-text-[14px] tw-font-semibold"
                    @click="() => { isCreatingReportModal = false }"> Cancel</button>
                <div>
                    <!-- <router-link :to="'/custom-report/' + selectedReportType"> -->
                        <button class="btn primarycolor tw-mt-[22px]" @click="postCreateReport" :disabled="isSavingReport">
                           Done
                        </button>
                    <!-- </router-link> -->
                </div>
          </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
import upDownCard from "@/views/v3/Components/upDownCard.vue";
import bar from "@/views/v3/Components/bar.vue";
import negativeColumnChart from "../commonCharts/Chart/negativeColumnChart.vue";
import noData from "../Components/noData.vue";
export default {
  name: "sos",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
    upDownCard,
    bar,
    noData,
    negativeColumnChart,
  },
  data() {
    return {
      dateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      modalDateRange: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: '',
      minDate: '',
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      tableLoader: false,
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map.Sentiment,
      viewReportsTableData: [],
      viewFilterAPIAllData: {},
      reportTypeList:[],
      selectedReportType: null,
      previousSelectedReportType: null,
      batchList: [],
      selectedBatch: null,
      previousSelectedBatch: null,
      userNameList: [],
      selectedUserName: null,
      previousSelectedUseName: null,
      statusList: [],
      selectedStatus: null,
      previousSelectedStatus: null,
      // report creation variables
      isCreatingReportModal: false,
      createReportTypeList: [],
      reportName: "",
      isSavingReport: false,
      flagError: false,
      reportNameErrorMessage: "",
      selectedCreatedReportType: null,
      createBatchList: [],
      selectedCreatedBatch: null,
      createChannelList: [],
      selectedCreatedChannel: null,
      previousSelectedCreatedChannel: null,
      dateRangeCreatedReport: {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      }
    };
  },
  mounted() {
    this.tableLoader = true;
    this.getFiltersData();
    this.$store.dispatch("DemoStore/setUpdatedStatus", "");
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "initializeTranslation",
    ]),
    // updateSelectedLabels(option) {
    //   return option.value.replaceAll("_", " ");
    // },
    formatData(value) {
      return value.toFixed(2);
    },
    handleApplyFilters() {
      if ($.fn.DataTable.isDataTable("#sentimentAnalysis")) {
        $("#sentimentAnalysis").DataTable().clear().destroy();
      }
      this.getReportsData();
    }, 
    // modal variable
    resetModal() {
      //  this.isCreatingReportModal = true;
      this.selectedCreatedBatch = null;
      this.selectedCreatedChannel = null;
      this.selectedCreatedReportType = null;
      this.reportName = "";
      this.dateRangeCreatedReport = {
        startDate: moment().subtract(1, "week").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      }
    },

    openModal(targetKeyword, sentType = "") {
      this.createReportTypeList = this.reportTypeList.filter(report => report.triger_id !== "all");
      this.isCreatingReportModal = true;
      this.resetModal();
    },

    handleReportSelection(selected) {
      const otherOptions = this.reportTypeList.filter((p) => p.triger_id !== "all");

      const isAllCurrentlySelected = selected.some((opt) => opt.triger_id === "all");
      const wasAllPreviouslySelected = this.previousSelectedReportType.some(
        (opt) => opt.triger_id === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedReportType = [...this.reportTypeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedReportType = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.triger_id !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedReportType = [...this.reportTypeList];
        } else {
          this.selectedReportType = [...selectedWithoutAll];
        }
      }

      this.previousSelectedReportType = [...this.selectedReportType];

        this.batchList = this.getBatchListData(this.selectedReportType.map((report)=>{return {...report.batches}}));
        this.selectedBatch = [...this.batchList];
        this.previousSelectedBatch = [...this.selectedBatch];
    },

    changeBatchTime(selected) {
      if(this.selectedReportType){
        const otherOptions = this.batchList.filter((p) => p.batch !== "all");

        const isAllCurrentlySelected = selected.some((opt) => opt.batch === "all");
        const wasAllPreviouslySelected = this.previousSelectedBatch.some(
          (opt) => opt.batch === "all"
        );

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedBatch = [...this.batchList];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedBatch = [];
        } else {
          const selectedWithoutAll = selected.filter((opt) => opt.batch !== "all");
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedBatch = [...this.batchList];
          } else {
            this.selectedBatch = [...selectedWithoutAll];
          }
        }

        this.previousSelectedBatch = [...this.selectedBatch];
      }
    },

    handleUsernameSelection(selected) {
      const otherOptions = this.userNameList.filter((p) => p.key !== "all");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousSelectedUseName.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedUserName = [...this.userNameList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedUserName = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedUserName = [...this.userNameList];
        } else {
          this.selectedUserName = [...selectedWithoutAll];
        }
      }

      this.previousSelectedUseName = [...this.selectedUserName];
    },

    handleStatusSelection(selected) {
      const otherOptions = this.statusList.filter((p) => p.key !== "all");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousSelectedStatus.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedStatus = [...this.statusList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedStatus = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedStatus = [...this.statusList];
        } else {
          this.selectedStatus = [...selectedWithoutAll];
        }
      }

      this.previousSelectedStatus = [...this.selectedStatus];
    },
  
    getFiltersData() {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/sense/excelDownloadFilter"
      self.$http
        .get(url)
        .then((response) => {
          this.viewFilterAPIAllData = response.data.data;
          this.reportTypeList = response.data.data.data
          this.reportTypeList.unshift({
            triger_id: "all",
            trigger_name: "All",
            batches: [],
            platforms:[],
          })
          this.selectedReportType = [...this.reportTypeList];
          this.previousSelectedReportType = [...this.selectedReportType];
          
          this.batchList = this.getBatchListData(this.selectedReportType.map((report)=>{return {...report.batches}}));
          this.selectedBatch = [...this.batchList];
          this.previousSelectedBatch = [...this.selectedBatch];

          this.userNameList = response.data.data.user;
          this.selectedUserName = [...this.userNameList];
          this.previousSelectedUseName = [...this.selectedUserName];

          this.statusList = response.data.data.status;
          this.selectedStatus = [...this.statusList];
          this.previousSelectedStatus = [...this.selectedStatus];
          this.getReportsData();
          self.vocProductListLoader = false;

        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },

    getBatchListData(batchList){
      const flattened = batchList.flatMap(obj => Object.values(obj));
      const unique = Array.from(
          new Map(flattened.map(item => [`${item.batch}-${item.time}`, item])).values()
      );
      return unique;
    },
    // create report section 
    handleCreateReporTypeSelection(selected){
    
      if(selected){
        this.createBatchList = [];
        this.createChannelList = [];
        this.createBatchList = selected.batches
        // this.selectedCreatedBatch = this.createBatchList[0];
        this.createChannelList = [...selected.platforms]
        // this.selectedCreatedChannel = [...this.createChannelList];
        // this.previousSelectedCreatedChannel = [...this.selectedCreatedChannel];
      }
    },

    handleCreateReportChannelSelection(selected){
       const otherOptions = this.createChannelList.filter((p) => p.key !== "all");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousSelectedCreatedChannel?.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedCreatedChannel = [...this.createChannelList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedCreatedChannel = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedCreatedChannel = [...this.createChannelList];
        } else {
          this.selectedCreatedChannel = [...selectedWithoutAll];
        }
      }

      this.previousSelectedCreatedChannel = [...this.selectedCreatedChannel];
    },

    postCreateReport(){
        if(!this.reportName.trim()){
           this.$bvToast.toast('Please Enter Report Name', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
          return;
        } 
        if(!this.selectedCreatedReportType){
          this.$bvToast.toast('Please select report type', {
            title: 'Error',
            variant: 'danger',
            solid: true
          });
          return;
        }
        const url = "/api/v2/indian_clients/all_report_excel/generalworker";
        const payload = {
          report_name: this.reportName,
          report_type: this.selectedCreatedReportType?.trigger_name,
          trigger_id: this.selectedCreatedReportType?.triger_id,
          batch: this.selectedCreatedBatch?.batch,
          platform: this.selectedCreatedChannel?.filter(data=>data.key!='all').map(channel => channel.key),
          website: this.selectedCreatedChannel?.filter(data=>data.key!='all').map(channel => channel.website),
          start_date: moment(this.dateRangeCreatedReport.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.dateRangeCreatedReport.endDate).format("YYYY-MM-DD"),
        }
  
        this.isSavingReport = true;
        this.$http.post(url, payload)
          .then((res) => {
            this.isSavingReport = false;
            this.isCreatingReportModal = false;
            this.$bvToast.toast('Report created successfully', {
              title: 'Success',
              variant: 'success',
              solid: true
            });
            this.getReportsData();
          })
          .catch((err) => {
            console.error(err);
            this.isSavingReport = false;
            this.$bvToast.toast('Failed to create report', {
              title: 'Error',
              variant: 'danger',
              solid: true
            });
          });
    },

    getReportsData() {
      // $("#sentimentAnalysis").DataTable().destroy();
      this.viewReportsTableData = [];

      this.tableLoader = true;
      const url = "/api/v2/indian_clients/all_report_excel/excel_logs";
      // console.log("Selected Report Type:", this.selectedReportType);
      const payload = {
        start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
        report_type: this.selectedReportType
          ?.filter((report) => report.trigger_name !== "All")
          .map((report) => report.trigger_name),
        trigger_id: this.selectedReportType
          ?.filter((report) => report.trigger_name !== "All")
          .map((report) => report.triger_id),
        batch: this.selectedBatch?.map((batch) => batch.batch),
        username: this.selectedUserName
          ?.filter((user) => user.key !== "all").map((user) => user.key),
        status: this.selectedStatus
          ?.filter((status) => status.key !== "all")
          .map((status) => status.key),
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.tableLoader = false;
          this.viewReportsTableData = res.data.data;
          //   this.tableData = res.data.data.data;
          this.$nextTick(() => {
            this.processTable("#sentimentAnalysis", 1);
          });
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
        });
    },

    processTable(id, sortCol = 0) {
      $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        sorting: false,
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });

      $(id + "_filter > label").append(`
          <div class='search_icon'>
              <img src='/Icons_SVG/Search.svg' width='20' />
          </div>
          `);
    },
    exportSentimentTable() {
      const url = "/api/v2/indian_clients/sentiment/sentiment_excel";
      const payload = {
        table: this.viewReportsTableData,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.customtooltiptext {
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text */
  left: 50%;
  margin-left: -60px;
  /* Fade in tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}

.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}

.tab-label {
  cursor: pointer;
  padding-bottom: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}

.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}

button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}

.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}

.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}

.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.modal-control-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #d4d4d4;

  & > ul {
    list-style: none;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    padding: 0;

    & > li {
      padding-bottom: 16px;
      margin: 0;
      font-size: 16px;
      cursor: pointer;
    }

    & > li.selected-tab {
      border-bottom: 1px solid #065559;
      margin-bottom: -1px;
      color: #065559;
      font-weight: 500;
    }
  }
}

.horizontal-divider {
  border-bottom: 1px solid #d9d9d9;
}

.vertical-divider {
  border-right: 1px solid #d9d9d9;
}

.customInput {
  border-radius: 5px !important;
  height: 35px !important;
  border: 1px solid #e4e7ea;
  width: 220px;
  outline: none;
  font-family: "poppins";
  width: 100%;
}
.modal-delete-content {
  color: var(--primary_brand);
  font-size: 16px;
  margin-bottom: 5px;
  font-family: "poppins";
}
.delete-alert {
  background-color: #ffecec !important;
  color: var(--red);
  font-size: 30px;
  width: 45px;
  height: 45px;
}

.delete-requestBtn:hover {
  background-color: #f58181 !important;
}
.btn-outline-danger:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: red !important;
}

.inputIconContainer {
    margin: 14px 14px 14px 16px;
}

button.password-toggle-btn:focus {
    background: #fff !important;
}

.inputIconContainer img {

    width: 16px !important;
    height: 16px !important;
}

.input-group {
    position: relative;
    margin-bottom: 1rem;
    flex-direction: column !important;
}

form.login-form label {
    font-size: 12px;
    font-weight: 400;
    font-family: "Poppins";
    color: #505050;
}

.input-group input {
    padding: 10px 12px 10px 40px;
    border: 1px solid #aeaeae;
    width: 100%;
    height: 100%;
    background: #fff !important;
    outline: none !important;
    border-radius: 5px;
    box-shadow: none !important;
}

.input-group input:focus {
    border: 1px solid var(--primary_brand) !important;
    outline: none !important;
    box-sizing: none !important;
}

.form-control::placeholder {
    color: #919191 !important;
    font-family: "poppins" !important;
    padding: 1.375rem 0.75rem !important;
    font-size: 0.9rem !important;
}

.danger {
    border-color: var(--red) !important;
    color: var(--red) !important;
}

.flagError {
    position: absolute;
    bottom: -30px;
}

</style>
<style>
#tableFilter .multiselect__strong {
  display: none !important;
}
</style>
